export default __webpack_public_path__ + "static/media/fross2.2d992b6d.png";